module.exports = __webpack_public_path__ + "static/media/NBA_analytics.11b44268.png";